export default {
    'image/jpeg': {
        ext: 'avi',
        type: 'image',
    },
    'image/png': {
        ext: 'png',
        type: 'image',
    },
    'video/x-msvideo': {
        ext: 'avi',
        type: 'video',
    },
    'video/mp4': {
        ext: 'mp4',
        type: 'video',
    },
    'video/avi': {
        ext: 'avi',
        type: 'video',
    },
    'application/x-troff-msvideo': {
        ext: 'avi',
        type: 'video',
    },
    'video/msvideo': {
        ext: 'avi',
        type: 'video',
    },
    'video/quicktime': {
        ext: 'mov',
        type: 'video',
    },
    'application/msword': {
        ext: 'doc',
        type: 'video',
    },
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
        ext: 'docx',
        type: 'document',
    },
    'application/pdf': {
        ext: 'pdf',
        type: 'document',
    },
};
